import React, { useState } from 'react';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Dialog } from '@fluentui/react/lib/Dialog';
import { ResponsiveMode } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import closeIcon from '../img/close.png';
import { useIdigestChatTheme } from '../ThemeContext';
import { getDialogThemeClassName, getThemedModalMainStyles } from './dialogStyles';
import { COMMON_DIALOG_CONTENT_STYLES, COMMON_HEADER_BUTTON_STYLES } from './shellStyles';

interface OneOnOneGreetingDialogProps {
  displayName?: string;
  onDismiss: () => void;
  onSubmit: (greeting: string) => Promise<boolean>;
}

export default function OneOnOneGreetingDialog({ displayName, onDismiss, onSubmit }: OneOnOneGreetingDialogProps) {
  const { t } = useTranslation();
  const { theme, tokens } = useIdigestChatTheme();
  const [greeting, setGreeting] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    const succeeded = await onSubmit(greeting.trim());
    if (!succeeded) {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      hidden={false}
      responsiveMode={ResponsiveMode.small}
      onDismiss={onDismiss}
      dialogContentProps={{
        showCloseButton: false,
        styles: {
          inner: { padding: '0px' },
          header: { height: '0px' },
          content: COMMON_DIALOG_CONTENT_STYLES
        }
      }}
      modalProps={{
        isBlocking: false,
        styles: { main: getThemedModalMainStyles(theme) },
        containerClassName: getDialogThemeClassName(theme)
      }}
    >
      <div className='header-section'>
        <div className='button-wrapper left-btn' />
        <h3 className='header-title' style={{ fontWeight: 600, fontSize: '18px' }}>
          {t('AddFriendScreen.AddFriend')}
        </h3>
        <div className='button-wrapper right-btn'>
          <DefaultButton className='header-button' styles={COMMON_HEADER_BUTTON_STYLES} onClick={onDismiss}>
            <img src={closeIcon} alt={t('Close')} className='button-icon' />
          </DefaultButton>
          <span className='button-label'>{t('Close')}</span>
        </div>
      </div>
      <div className='add-friend-body'>
        {displayName ? <p style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 600 }}>{displayName}</p> : null}
        <div className='add-friend-field'>
          <p className='add-friend-label'>{t('AddFriendScreen.SelfIntro')}</p>
          <textarea
            id='initialContactIntroduction'
            className='dialog-box'
            value={greeting}
            onChange={(event) => setGreeting(event.target.value)}
            rows={4}
            autoFocus
          />
        </div>
        <DefaultButton
          onClick={() => void handleSubmit()}
          disabled={submitting}
          styles={{
            root: {
              margin: '12px auto 0',
              minWidth: 120,
              backgroundColor: tokens.fg,
              color: tokens.bg,
              borderRadius: '25px',
              border: 'none'
            },
            rootHovered: { backgroundColor: tokens.surfaceHover, color: tokens.fg },
            rootDisabled: { backgroundColor: tokens.muted, color: tokens.bg, cursor: 'not-allowed' }
          }}
        >
          {submitting ? t('Loading') : t('OK')}
        </DefaultButton>
      </div>
    </Dialog>
  );
}
